import { Dialog, DialogTitle, DialogContent, Button, DialogActions } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import TextField from "../../../../components/form/TextField";
import { useSaveQueryMutation } from "../../../../api/dataWranglerApiSlice";
import { useSelector } from "react-redux";
import { selectWizardState } from "../../dataWranglerSlice";

interface Props {
    open: boolean;
    close: () => void;
}

interface FormValues {
    title: string;
    description: string;
}

const SaveWizardQuery = (props: Props) => {
    const { control, handleSubmit, formState: { errors }, resetField } = useForm<FormValues>({
        defaultValues: {
            title: "",
            description: ""
        }
    });
    const [ saveQuery ] = useSaveQueryMutation();
    const [clickedSaved, setClickedSaved] = useState(false);
    const selectedWizardState = useSelector(selectWizardState);

    const onSubmit = async (newData: FormValues) => {
        setClickedSaved(true);
        try {
            await saveQuery({
                title: newData.title,
                description: newData.description,
                type: 'private',
                builder: 'wizard',
                query: {
                    ...selectedWizardState
                }
            });
            resetField('title');
            resetField('description');
            props.close()
            setClickedSaved(false);
        } catch (err) {
            console.error("SAVE ERROR", err);
        }
    }

    const onCancel = () => {
        resetField('title');
        resetField('description');
        props.close();
        setClickedSaved(false);
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.close}
            fullWidth={true}
            maxWidth={'sm'}
        >
            <DialogTitle>Save Query</DialogTitle>
            <DialogContent>
                <form
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        minWidth: 356,
                    }}
                >
                    <Controller
                        name={"title"}
                        control={ control }
                        rules={{
                            required: true,
                            pattern: /^(\s+\S+\s*)*(?!\s).*$/,
                            maxLength: {
                                value: 100,
                                message: 'Title should be 100 characters or less'
                            }
                        }}
                        render={({ field }) => (
                            <TextField
                                label={"Details"}
                                error={errors.title ? true : false }
                                required={true}
                                errorMessage={errors.title?.message}
                                { ...field }
                            />
                        )}
                    />
                    <Controller
                        name={"description"}
                        control={ control }
                        rules={{
                            required: true,
                            pattern: /^(\s+\S+\s*)*(?!\s).*$/,
                            maxLength: {
                                value: 255,
                                message: 'Description should be 255 characters or less'
                            }
                        }}
                        render={({ field }) => (
                            <TextField
                                label={"Description"}
                                textBox={true}
                                required={true}
                                error={errors.description ? true : false }
                                errorMessage={errors.description?.message}
                                { ...field }
                            />
                        )}
                    />
                </form>
            </DialogContent>
            <DialogActions>
                <Button disabled={clickedSaved} variant="tertiary" onClick={onCancel}>Cancel</Button>
                <Button disabled={clickedSaved} variant="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SaveWizardQuery;